import { createTheme } from "@mui/material/styles";
const theme = createTheme({
  palette: {
    primary: {
      main: "#162395"
    },
    secondary: {
      main: "#0D1559", // Custom color
    },
  },
  typography: {
    fontFamily: '"IBM Plex Serif", serif',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: '"IBM Plex Serif", serif',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"IBM Plex Serif", serif',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          fontFamily: '"IBM Plex Serif", serif',
        },
      },
    },
    // Add more MUI components as needed
    MuiPickersDay: {
      styleOverrides: {
        today: {
          border: '1px solid #FFCC33',
          backgroundColor: 'transparent',
          color: 'inherit',
        },
        root: {
          '&.Mui-selected.MuiPickersDay-today': {
            backgroundColor: '#FFCC33',
            color: '#000',
          },
        },
      },
    },

    MuiTabs: {
      styleOverrides: {
        root: {
          fontFamily: '"IBM Plex Serif", serif !important',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: '"IBM Plex Serif", serif !important',
          textTransform: 'none',
        },
      },
    },

  },

});

export default theme
